<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap>
				<app-card :fullBlock="true" colClasses="xs12">
					<v-container>
						<v-layout row wrap>
							<v-flex xs12 sm6>
								<h3>{{ $t("message.exchangeRate") }}</h3>
								<v-switch
									:label="
										hasManualRate
											? $t('message.manual')
											: $t('message.yadioRate')
									"
									v-model="hasManualRate"
									color="primary"
									hide-details
								></v-switch>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs12 sm6 v-show="!hasManualRate">
								<v-text-field
									prefix="%"
									:label="$t('message.percentageAboveDollar')"
									data-vv-name="dollarPercentage"
									v-model="dollarPercentage"
									v-validate="'decimal:2|between:-100,100'"
									:error-messages="errors.collect('dollarPercentage')"
								></v-text-field>
							</v-flex>
							<v-flex xs12 sm6 v-show="hasManualRate">
								<v-text-field
									prefix="VES"
									:label="$t('message.manualExchangeRate')"
									data-vv-name="dollarRate"
									v-model="dollarPrice"
									v-validate="'decimal:2'"
									:error-messages="errors.collect('dollarRate')"
								></v-text-field>
							</v-flex>
							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.ratePreview')"
									prefix="VES"
									v-model="ratePreview"
									disabled
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-btn @click="updateDollarRate" color="primary" outline>{{
							$t("message.saveRate")
						}}</v-btn>
					</v-container>

					<v-card-title>
						<h3>{{ $t("message.paymentMethods") }}</h3>
						<v-btn @click.stop="onAdd" color="primary" outline>
							<i class="material-icons">add</i>
							{{ $t("message.addNew") }}
						</v-btn>
						<v-spacer></v-spacer>
						<v-text-field
							append-icon="search"
							hide-details
							:label="$t('message.search')"
							single-line
							v-model="search"
						></v-text-field>
					</v-card-title>

					<v-data-table :headers="headers" :items="items" :search="search">
						<template slot="headerCell" slot-scope="props">
							<span>{{ $t(`message.${props.header.text}`) }}</span>
						</template>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.bank_name }}</td>
							<td>{{ props.item.account_type }}</td>
							<td>{{ props.item.account_number }}</td>
							<td>{{ props.item.owner_full_name }}</td>
							<td>{{ props.item.owner_document }}</td>
							<td class="text-left">
								<v-tooltip top>
									<v-btn
										@click="onEdit(props.item)"
										color="primary"
										outline
										fab
										icon
										small
										slot="activator"
									>
										<v-icon class="zmdi zmdi-edit"></v-icon>
									</v-btn>
									<span>{{ $t("message.edit") }}</span>
								</v-tooltip>
								<v-tooltip top>
									<v-btn
										@click="onDelete(props.item)"
										class="trash-icon"
										color="error"
										outline
										fab
										icon
										slot="activator"
										small
									>
										<v-icon light>cancel</v-icon>
									</v-btn>
									<span>{{ $t("message.delete") }}</span>
								</v-tooltip>
							</td>
						</template>
					</v-data-table>
					<delete-confirmation-dialog
						@onConfirm="deleteBank"
						:heading="$t('message.deleteConfirmation')"
						:message="$t('message.deleteMessage')"
						ref="deleteConfirmationDialog"
					></delete-confirmation-dialog>
					<bank-manage
						:dialog.sync="showModal"
						@on-save="onSave"
						ref="bankManageModal"
						:is-edit="!isCreate"
					></bank-manage>
				</app-card>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import api from "../../api/apibackend";
import { mapGetters } from "vuex";
import BankManage from "./BankManage";
import { userRoles } from "../../constants/constants";
import {
	CREATE_BANK,
	UPDATE_BANK,
	DELETE_BANK,
	GET_BANKS,
	GET_COMPANY_BANKS,
	CREATE_COMPANY_BANK,
	UPDATE_COMPANY_BANK,
	DELETE_COMPANY_BANK,
} from "../../store/modules/banks/actions.type";
import {
	UPDATE_STORE,
	GET_STORE_USER_AUTH,
} from "../../store/modules/storeModule/actions.type";

export default {
	name: "bankList",
	components: {
		BankManage,
	},
	data() {
		return {
			headers: [
				{ text: "paymentMethod", sortable: true, value: "bank_name" },
				{ text: "currency", sortable: true, value: "account_type" },
				{
					text: "accountNumberEmailPhone",
					sortable: true,
					value: "account_number",
				},
				{ text: "ownerName", sortable: true, value: "owner_full_name" },
				{ text: "ownerDocument", sortable: true, value: "owner_document" },
				{ text: "actions", sortable: false, value: "" },
			],
			search: "",
			showModal: false,
			showModalImage: false,
			isCreate: true,
			selectedBank: {},
			exchangeRate: 0,
			hasManualRate: false,
			dollarPercentage: 0,
			dollarPrice: 0,
		};
	},
	computed: {
		...mapGetters(["banks", "companyBanks"]),
		roleUser() {
			let userData = JSON.parse(localStorage.getItem("userData"));
			return userData.role_id;
		},
		items() {
			let items = [];

			if (this.roleUser == userRoles.CLIENT) {
				items = [...this.banks];

				this.generateDocumentationProp(items);
				return items;
			}

			items = [...this.companyBanks];

			this.generateDocumentationProp(items);
			return items;
		},
		ratePreview() {
			if (this.hasManualRate) {
				return this.dollarPrice || "";
			}
			return `${Math.ceil(
				this.exchangeRate * this.dollarPercentage * 0.01 + this.exchangeRate
			).toLocaleString()}`;
		},
	},
	created() {
		if (this.roleUser == userRoles.CLIENT) this.getBanks();
		else this.getCompanyBanks();
		this.getExchangeRate();
		this.getUserStore();
	},
	methods: {
		getExchangeRate() {
			api
				.get("/dollar", {})
				.then((res) => {
					this.exchangeRate = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		deleteBank() {
			if (this.roleUser == userRoles.CLIENT)
				this.$store.dispatch(DELETE_BANK, this.selectedBank.id);
			else this.$store.dispatch(DELETE_COMPANY_BANK, this.selectedBank.id);

			this.$refs.deleteConfirmationDialog.close();
		},
		getBanks() {
			this.$store.dispatch(GET_BANKS);
		},
		getCompanyBanks() {
			this.$store.dispatch(GET_COMPANY_BANKS);
		},
		generateDocumentationProp(items) {
			items.forEach((item) => {
				item.owner_document =
					item.owner_idenfication_type + "-" + item.owner_idenfication;
			});
		},
		onAdd() {
			this.showModal = true;
			this.isCreate = true;
		},
		onDelete(bank) {
			this.selectedBank = bank;
			this.$refs.deleteConfirmationDialog.openDialog();
		},
		onEdit(bank) {
			this.$refs.bankManageModal.setValue(bank);
			this.showModal = true;
			this.isCreate = false;
			this.selectedBank = bank;
		},
		async onSave(bank) {
			if (this.isCreate) {
				if (this.roleUser == userRoles.CLIENT)
					await this.$store.dispatch(CREATE_BANK, bank);
				else await this.$store.dispatch(CREATE_COMPANY_BANK, bank);
			} else {
				this.selectedBank = Object.assign({}, this.selectedBank, bank);

				if (this.roleUser == userRoles.CLIENT)
					await this.$store.dispatch(UPDATE_BANK, this.selectedBank);
				else await this.$store.dispatch(UPDATE_COMPANY_BANK, this.selectedBank);
			}

			this.$refs.bankManageModal.resetForm();
		},
		updateDollarRate() {
			let storeData = {
				id: this.id,
				dollar_percent: this.dollarPercentage,
				dollar_price: this.dollarPrice,
			};
			if (!this.hasManualRate) {
				storeData.dollar_price = null;
			}
			this.$store.dispatch(UPDATE_STORE, storeData);
		},
		getUserStore() {
			this.$store.dispatch(GET_STORE_USER_AUTH).then((res) => {
				if (res) {
					this.id = res.id;
					this.dollarPercentage = res.dollar_percent;
					this.dollarPrice = res.dollar_price;
					this.hasManualRate = res.dollar_price ? true : false;
				}
			});
		},
	},
};
</script>

<style></style>
